export default function formatNumberWithCommasAndDecimal(amount, precision) {
  return numberWithCommas(amount.toFixed(precision));
}

function numberWithCommas(value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
